import { render } from "./SecondPage.vue?vue&type=template&id=4d79631c&scoped=true"
import script from "./SecondPage.vue?vue&type=script&lang=js"
export * from "./SecondPage.vue?vue&type=script&lang=js"

import "./SecondPage.vue?vue&type=style&index=0&id=4d79631c&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d79631c"]])

export default __exports__